import { images } from "../constants";

const home = {
        image: images.home, // Home Image
        subtitle: "26 - 29 November, 2025 | Taipei, TW", // Event Dates & Location
        headingPart1: "",
        spanText: "AI ROBOTIC",
        headingPart2: "Make things possible in future.",
        buttonText: "Registration",
        buttonLink: "Tickets",
};

export default home;